import { RootState } from '../reducers'

export const SurveysSelector = (state: RootState, id: string) => (state.surveys.pages && state.surveys.pages[id] ? state.surveys.pages[id].content : [])

export const lastPageSelector = (state: RootState, id: string) => (state.surveys.pages && state.surveys.pages[id] ? state.surveys.pages[id].last : null)

export const surveysPagingSelector = (state: RootState, id: string) => (state.surveys.pages && state.surveys.pages[id] ? state.surveys.pages[id] : null)
